import React from "react";
import { Input, Check, Textarea } from "../../";
import locales from "../../../constants";

const SecondStep = ({ register, errors, step, setStep, lang }) => {
  const translation = locales[lang];
  return (
    <div
      className="step_2 stepWrapper"
      style={{ display: step === 2 ? "block" : "none" }}
    >
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_domain_yes}</h4>
          <p>{translation.brief_shop.step_2_domain_no}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="your_domain"
            label={translation.brief_shop.step_2_domain}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_group_head}</h4>
          <p>{translation.brief_shop.step_2_group_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="target_group"
            label={translation.brief_shop.step_2_group}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_strong_prod_head}</h4>
          <p>{translation.brief_shop.step_2_strong_prod_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="strong_side"
            label={translation.brief_shop.step_2_strong_prod}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_weak_prod_head}</h4>
          <p>{translation.brief_shop.step_2_weak_prod_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="weak_side"
            label={translation.brief_shop.step_2_weak_prod}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_concurency_head}</h4>
          <p>{translation.brief_shop.step_2_concurency_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="competition"
            label={translation.brief_shop.step_2_concurency}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_store_head}</h4>
          <p>{translation.brief_shop.step_2_store_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="inspiration"
            label={translation.brief_shop.step_2_store}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_website_head}</h4>
          <p>{translation.brief_shop.step_2_website_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="bad_services"
            label={translation.brief_shop.step_2_website}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_colors_head}</h4>
          <p>{translation.brief_shop.step_2_colors_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="colors"
            label={translation.brief_shop.step_2_colors}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_company_head}</h4>
          <p>{translation.brief_shop.step_2_company_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="materials"
            label={translation.brief_shop.step_2_company}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_products_head}</h4>
          <p>{translation.brief_shop.step_2_products_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="products_amount"
            label={translation.brief_shop.step_2_products}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_language_head}</h4>
          <p>{translation.brief_shop.step_2_language_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <div className="row">
            <div className="col-sm-4">
              <Check
                register={register}
                name="english"
                label={translation.brief_shop.step_2_language_eng}
              />
            </div>
            <div className="col-sm-4">
              <Check
                register={register}
                name="germany"
                label={translation.brief_shop.step_2_language_ger}
              />
            </div>
            <div className="col-sm-4">
              <Check
                register={register}
                name="french"
                label={translation.brief_shop.step_2_language_fre}
              />
            </div>
            <div className="col-sm-4">
              <Check
                register={register}
                name="spain"
                label={translation.brief_shop.step_2_language_span}
              />
            </div>
            <div className="col-sm-4">
              <Check
                register={register}
                name="italy"
                label={translation.brief_shop.step_2_language_ita}
              />
            </div>
            <div className="col-sm-4">
              <Check
                register={register}
                name="russian"
                label={translation.brief_shop.step_2_language_rus}
              />
            </div>
          </div>

          <Input
            type="text"
            name="other_language"
            label={translation.brief_shop.step_2_language_other}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_map_store_head}</h4>
          <p>{translation.brief_shop.step_2_map_store_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            cols="40"
            rows="3"
            name="shop_map"
            label={translation.brief_shop.step_2_map_store}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_shop.step_2_invest_head}</h4>
          <p>{translation.brief_shop.step_2_invest_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Input
            type="text"
            name="shop_cost"
            label={translation.brief_shop.step_2_invest}
            register={register}
            errors={errors}
          />
          <a
            className="input-link"
            href="/blog/strony-internetowe/z-czego-wynika-budzet-projektow-it/"
            target="_blank"
          >
            {translation.brief_light.brief_light_why}
          </a>
        </div>
      </div>
      <div className="btn-brief-group">
        <button
          type="button"
          className="btn_brief stepWrapperBtn"
          onClick={() => setStep(1)}
        >
          {translation.brief_shop.step_1_prev_step}
        </button>
        <button
          className="btn_brief stepWrapperBtn"
          type="button"
          onClick={() => setStep(3)}
        >
          {translation.brief_shop.step_1_next_step}
        </button>
      </div>
    </div>
  );
};

export default SecondStep;
